<script lang="ts" setup>
import { NO_CONTENT } from "~/modules/dtwin/constants";
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DynamicUIDetail } from "~/modules/dtwin/models/DynamicUIDetail.interface";
import { getValue } from "~/modules/dtwin/utils/getOptionValue";

defineProps<{
  item: DynamicUIDetail;
  dtwin: Dtwin;
}>();
</script>
<template>
  <lxc-form-item :label="item.label || ''" display-label read-only>
    <div class="text-gray-700 font-medium text-[1.14286em]">
      <template v-if="item.formattingProcess">
        <dtwin-formatting-process :dynamic-ui="item" :dtwin="dtwin" />
      </template>
      <template v-else>
        {{ getValue(item.id, dtwin) || NO_CONTENT }}
      </template>
    </div>
  </lxc-form-item>
</template>
